export default {
  page: {
    home: "Inicio",
    search: "Buscar",
    skills: "Competencias",
    skills_stats: "Estadísticas",
    dashboard: "Tablero de control",
    questionnaires: "Cuestionarios",
    weblinks: "Enlaces útiles",
    gradebook: "Sus boletines de notas",
    attestations: "Sus certificados de asistencia",
    message: "Mensajes",
    document: "Sus documentos compartidos",
    document_add: "Añadir un documento",
    document_add_note: "Añadir una nota",
    lessons: "Sus cursos",
    timetable: "Su empleo del tiempo",
    absence: "Gestión de asistencia",
    profile: "Perfil",
    questionnaire: "Cuestionario",
    training_course_list: "Lista de promociones",
    training_list: "Lista de formaciones",
    registration_dashboard: "Panel de registro",
    training_dashboard: "Tablero de control de la formación",
    pre_registration: "Ficha de preinscripción",
    pre_registration_edit: "Configuración del formulario de preinscripción",
    step_edit: "Configuración de pasos",
    contract: "Contrato",
    driver_licence_config: "Gestión de las bonificaciones del permiso de conducción B",
    driver_licence_list: "Lista de solicitudes de ayuda para el permiso de conducción B",
    driver_licence: "Ayuda con el permiso de conducir B",
    login: "Conexión",
    notepad: "Bloc de notas",
    new_message: "Nuevo mensaje",
    new_password: "Nueva contraseña",
    reset_password: "Restablecer su contraseña",
    error: "Error",
    switch: "Conexión",
    maintenance: "Mantenimiento",
    download: {
      title: "Descarga de archivo",
      processing: "Descarga en curso...",
      success: "¡Archivo descargado con éxito!",
    },
    platformNotFount: "Plataforma no configurada",
    registration_list: "Lista de formularios de preinscripción",
  },
};
